
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
 name:"esg",
 components: {
   CommonTitle,
   BannerTop,
   // Notice
 },
 data() {
    return {
      bannerUrl:require("~/static/images/esg/banner.png"),
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/esg/1.png`),
          imgStyle:{
            width:"386px",
            height:"516px"
          }
        }
      ],
    }
  },
  computed: {
    contentList () {
      return this.$t('esg.contentList')
    },
  },
}
